import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SdHeadingComponent } from '@sdvor/seo/ui';
import { DeviceService } from '@shared/services';
import { IconTypes } from '@shared/v2';
import { OfflineOrdersListComponent } from './offline-orders-list';
import { OnlineOrdersListModule } from './online-orders-list';
import { OrderHistoryFilterComponent } from './order-history-filter';
import { OrderHistoryPageComponentService, OrderListTypes } from './order-history-page.component-service';

@Component({
  selector: 'sd-order-history-page',
  imports: [OnlineOrdersListModule, OfflineOrdersListComponent, OrderHistoryFilterComponent, SdHeadingComponent],
  templateUrl: './order-history-page.component.html',
  styleUrls: ['./order-history-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [OrderHistoryPageComponentService],
})
export class OrderHistoryPageComponent {
  iconTypes = IconTypes;
  orderListTypes = OrderListTypes;

  isTabletUp = toSignal(this.deviceService.isTabletMdUp$);

  orderListType = computed(() => this.orderHistoryPageComponentService.orderListType());

  constructor(
    private deviceService: DeviceService,
    private orderHistoryPageComponentService: OrderHistoryPageComponentService,
  ) {}
}
